"use client";

import { c as _c } from "react/compiler-runtime";
import { captureException } from "@sentry/nextjs";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";
import { FC, useEffect } from "react";
export const NotFoundComponent: FC = () => {
  const $ = _c(4);
  const baseUrl = `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/images/`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <picture><source media="(max-width: 768px)" srcSet={`${baseUrl}328x168/404.png`} /><source media="(min-width: 768px)" srcSet={`${baseUrl}404.png`} /><img alt="not found" src={`${baseUrl}404.png`} /></picture>;
    t2 = <p className="md:text-headline-6 text-subtitle-2">صفحه‌ای که دنبال آن بودید پیدا نشد!</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex h-[calc(100vh-4rem)] items-center justify-center bg-white"><div className="flex flex-col items-center gap-6">{t1}{t2}<Button role="link" EndIcon={<MaterialIcon name="chevron_left" />} color="secondary" href="/" text={"\u0635\u0641\u062D\u0647 \u0627\u0635\u0644\u06CC"} variant="outline" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp() {
  captureException("error in not-found", {
    tags: {
      errorType: "globalError",
      url: window.location.href,
      referrer: document.referrer,
      channel: getChannel() as Channels,
      appName: process.env.NEXT_PUBLIC_APP_NAME,
      appVersion: process.env.NEXT_PUBLIC_IMAGE_VERSION
    }
  });
}